export class Regex {
  constructor(navigator: Navigator) {
    this.navigator = navigator;
  }
  navigator: Navigator;

  appleDeviceRegex = /Mac|iPhone|iPad|iPod/;
  safariNavigatorRegex = /^((?!Chrome|Android).)*Safari/;

  isAppleDevice(): boolean {
    return this.getAppleDevice(this.navigator.userAgent);
  }

  private getAppleDevice(userAgent: string): boolean {
    return this.appleDeviceRegex.test(userAgent);
  }

  isSafariNavigator(): boolean {
    return this.getSafariNavigator(this.navigator.userAgent);
  }

  private getSafariNavigator(userAgent: string) {
    return this.safariNavigatorRegex.test(userAgent);
  }
}
